/**
* Treatments Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Treatments Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import {Splide} from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'treatments-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.treatments-slider' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--treatments-slider' )[0], {
          type: 'loop',
          pagination: false,
          arrows: true,
          gap: '20px',
          // autoWidth: true,
          perPage: 2,
          perMove: 1,
          padding: {
            left: '20%',
            right: '20%',
          },
          breakpoints: {
            1440: {
              padding: {
                left: '190px',
                right: '190px',
              },
            },
            1024: {
              perPage: 1,
            },
            640: {
              perPage: 1,
              padding: {
                left: '40px',
                right: '40px',
              },
            },
          },
        } );

        splide.mount();
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'treatments-slider', COMPONENT );
} )( app );
